import React, { useState } from 'react';
import { ComboBox, Button, Tag } from '@carbon/react';
import { TrashCan, Image as ImageIcon } from '@carbon/react/icons';

import { useGetElementsQuery } from '@/redux/new_services/elements';
import MediaPreview, { previewSrc } from './MediaPreview';

// VariantSlotPicker — represents one of the two media slots of a variant
// (landscape or portrait). Shows the currently linked media as a small
// thumbnail; clicking the picker reveals a ComboBox of unpaired media of
// the matching orientation. Empty slots are allowed — a variant that only
// covers one format is fine.
const VariantSlotPicker = ({
  label,
  orientation,        // 0 = landscape, 1 = portrait
  media,              // currently linked Media object or null
  onSelect = () => {},
  onClear = () => {},
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);

  const filterValue = orientation === 0 ? 'orientation_landscape' : 'orientation_portrait';

  // Only fetch candidates when the picker is open — saves a request when the
  // form is just being viewed. Limit is generous; admins rarely have a
  // single orientation count high enough to overflow.
  const { data } = useGetElementsQuery(
    { skip: 0, limit: 200, filter: { orientation: [filterValue] } },
    { skip: !pickerOpen },
  );
  const candidates = (data?.data || []).filter((m) => m.orientation === orientation);

  return (
    <div className="variant-slot">
      <div className="variant-slot__label">{label}</div>
      {media ? (
        <div className="variant-slot__current">
          {previewSrc(media) ? (
            <div className="variant-slot__media">
              <MediaPreview media={media} fit="cover" />
            </div>
          ) : (
            <div className="variant-slot__placeholder"><ImageIcon size={20} /></div>
          )}
          <div className="variant-slot__current-meta">
            <span className="variant-slot__current-name">{media.name}</span>
            <Tag type="cool-gray" size="sm">{orientation === 0 ? 'Quer' : 'Hoch'}</Tag>
          </div>
          <Button
            kind="ghost"
            size="sm"
            hasIconOnly
            renderIcon={TrashCan}
            iconDescription="Slot leeren"
            onClick={onClear}
          />
        </div>
      ) : (
        <div className="variant-slot__empty">
          {!pickerOpen ? (
            <Button kind="ghost" size="sm" onClick={() => setPickerOpen(true)}>
              Element auswählen
            </Button>
          ) : (
            <ComboBox
              id={`variant-slot-${label}-${orientation}`}
              titleText=""
              hideLabel
              placeholder="Element suchen…"
              items={candidates}
              itemToString={(c) => (c ? c.name : '')}
              onChange={(e) => {
                if (e?.selectedItem) {
                  onSelect(e.selectedItem);
                  setPickerOpen(false);
                }
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default VariantSlotPicker;
